import { useState } from 'react';
import { TableInput } from '../../../../../components/common';
import ObservationInput from './ObservationInput';
import { Checkbox, MenuItem } from '@mui/material';
import CustomSelect from '../../../../../components/common/SelectField';
import formatDate from '../../../../../components/common/formatDate';
import AutocompleteMuiCustom from '../../../../../components/common/AutocompleteMuiCustom';

interface IProps {
  moduleData: any;
  tabValue: number;
  isView: boolean;
  machineData?: any;
  vedorData?: any;
}
const TBody = ({
  moduleData,
  tabValue,
  isView,
  machineData,
  vedorData,
}: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <tbody>
      {moduleData.riInspections[tabValue] &&
        moduleData.riInspections[tabValue].inspection_list &&
        moduleData.riInspections[tabValue].inspection_list.map(
          (spec: any, index: number) => (
            <tr key={index + tabValue + 11.333 + 'specs'}>
              {index === 0 && (
                <th
                  rowSpan={
                    moduleData?.riInspections[tabValue]?.inspection_list?.length
                  }
                  style={{ minWidth: '90px' }}
                >
                  {formatDate(moduleData.moduleData_date)}
                </th>
              )}
              {index === 0 && (
                <th
                  rowSpan={
                    moduleData?.riInspections[tabValue]?.inspection_list?.length
                  }
                  style={{ minWidth: '150px' }}
                >
                  <AutocompleteMuiCustom
                    id="fixtures"
                    label=""
                    option_name="vender_name"
                    key={'fixtures'}
                    arrayofObj={vedorData}
                    value={moduleData.riInspections[tabValue].vender_id || ''}
                    onChange={(e, value) => {
                      moduleData.riInspections[tabValue].vender_id = value;
                      setRender((prev) => !prev);
                    }}
                    sx={{ width: '350px' }}
                  />
                </th>
              )}
              {index === 0 && (
                <th
                  rowSpan={
                    moduleData?.riInspections[tabValue]?.inspection_list?.length
                  }
                  style={{ minWidth: '200px' }}
                >
                  {moduleData.part_name
                    ? moduleData.part_name
                    : moduleData.part_id?.part_name}
                </th>
              )}
              {index === 0 && (
                <th
                  rowSpan={
                    moduleData?.riInspections[tabValue]?.inspection_list?.length
                  }
                  style={{ minWidth: '100px' }}
                >
                  <TableInput
                    name="rm_grade"
                    type="text"
                    value={moduleData.riInspections[tabValue].rm_grade}
                    onChange={(e) => {
                      moduleData.riInspections[tabValue].rm_grade =
                        e.target.value;
                      setRender((prev) => !prev);
                    }}
                    isView={isView}
                  />
                </th>
              )}
              {index === 0 && (
                <th
                  rowSpan={
                    moduleData?.riInspections[tabValue]?.inspection_list?.length
                  }
                  style={{ minWidth: '100px' }}
                >
                  <TableInput
                    name="size"
                    type="text"
                    value={moduleData.riInspections[tabValue].size}
                    onChange={(e) => {
                      moduleData.riInspections[tabValue].size = e.target.value;
                      setRender((prev) => !prev);
                    }}
                    isView={isView}
                  />
                </th>
              )}
              {index === 0 && (
                <th
                  rowSpan={
                    moduleData?.riInspections[tabValue]?.inspection_list?.length
                  }
                  style={{ minWidth: '100px' }}
                >
                  <TableInput
                    name="qty"
                    type="number"
                    value={moduleData.riInspections[tabValue].qty}
                    onChange={(e) => {
                      moduleData.riInspections[tabValue].qty = e.target.value;
                      setRender((prev) => !prev);
                    }}
                    isView={isView}
                  />
                </th>
              )}
              {index === 0 && (
                <th
                  rowSpan={
                    moduleData?.riInspections[tabValue]?.inspection_list?.length
                  }
                  style={{ minWidth: '150px' }}
                >
                  <TableInput
                    name="batch_no"
                    type="text"
                    value={moduleData.riInspections[tabValue].batch_no}
                    onChange={(e) => {
                      moduleData.riInspections[tabValue].batch_no =
                        e.target.value;
                      setRender((prev) => !prev);
                    }}
                    isView={isView}
                  />
                </th>
              )}
              <td style={{ minWidth: '200px' }}>{spec.methods}</td>
              <td colSpan={2} style={{ minWidth: '200px' }}>
                {spec.specification}
              </td>
              {/* <td style={{ minWidth: '200px' }}>
                {spec?.utolerance &&
                  spec?.utolerance === spec?.ltolerance &&
                  '±' + spec?.utolerance}
                {spec?.utl && spec?.utl}
                {spec?.ltl && spec?.ltl}
              </td> */}
              {Array.from({ length: 5 }, (_, obsIndex) => (
                <td
                  key={obsIndex + 'obs'}
                  style={{ textTransform: 'uppercase', minWidth: '120px' }}
                >
                  <ObservationInput
                    {...{ spec, setRender, isView, obsIndex }}
                    obsNumber={0}
                    checkType={spec.appearance}
                  />
                </td>
              ))}
              <td style={{ minWidth: '150px' }}>
                <TableInput
                  name="free_from_visual_defect"
                  type="text"
                  value={spec.free_from_visual_defect}
                  onChange={(e) => {
                    spec.free_from_visual_defect = e.target.value;
                    setRender((prev) => !prev);
                  }}
                  isView={isView}
                />
              </td>
              <td style={{ textTransform: 'uppercase', minWidth: '100px' }}>
                {spec.appearance === 'check3' ? (
                  isView ? (
                    spec.result
                  ) : (
                    <CustomSelect
                      name="dropdown"
                      value={spec.result || ''}
                      onChange={(e) => {
                        spec.result = e.target.value;
                        setRender((prev) => !prev);
                      }}
                      sx={{
                        textAlign: 'center',
                      }}
                    >
                      <MenuItem value="">NONE</MenuItem>
                      <MenuItem value="ok">OK</MenuItem>
                      <MenuItem value="ng">NG</MenuItem>
                    </CustomSelect>
                  )
                ) : (
                  spec.result
                )}
              </td>
              {index === 0 && (
                <th
                  rowSpan={
                    moduleData?.riInspections[tabValue]?.inspection_list?.length
                  }
                  style={{ minWidth: '150px' }}
                >
                  <TableInput
                    name="inspected_by"
                    type="text"
                    value={moduleData.riInspections[tabValue].inspected_by}
                    onChange={(e) => {
                      moduleData.riInspections[tabValue].inspected_by =
                        e.target.value;
                      setRender((prev) => !prev);
                    }}
                    isView={isView}
                  />
                </th>
              )}
              {index === 0 && (
                <th
                  rowSpan={
                    moduleData?.riInspections[tabValue]?.inspection_list?.length
                  }
                  style={{ minWidth: '150px' }}
                >
                  <TableInput
                    name="verified_by"
                    type="text"
                    value={moduleData.riInspections[tabValue].verified_by}
                    onChange={(e) => {
                      moduleData.riInspections[tabValue].verified_by =
                        e.target.value;
                      setRender((prev) => !prev);
                    }}
                    isView={isView}
                  />
                </th>
              )}
              <td colSpan={isView ? 2 : 1} style={{ minWidth: '150px' }}>
                <TableInput
                  name="remarks"
                  type="text"
                  value={spec.remarks}
                  onChange={(e) => {
                    spec.remarks = e.target.value;
                    setRender((prev) => !prev);
                  }}
                  isView={isView}
                />
              </td>
              {!isView && (
                <td style={{ minWidth: '150px' }}>
                  <Checkbox
                    name="changeCheckbox"
                    checked={spec.appearance === 'check3'}
                    onChange={() => {
                      if (spec.prev_appearance) {
                        spec.appearance = spec.prev_appearance;
                        spec.prev_appearance = null;
                      } else {
                        spec.prev_appearance = spec.appearance;
                        spec.appearance = 'check3';
                      }
                      setRender((prev) => !prev);
                    }}
                    style={{ color: '#064a29' }}
                  />
                </td>
              )}
            </tr>
          ),
        )}
    </tbody>
  );
};

export default TBody;
